import axios from 'axios';
import { API_BASE_URL } from '../../config/api';

const packageService = {
  getAllPackages: async (filters = {}) => {
    const response = await axios.get(`${API_BASE_URL}/packages`, {
      params: filters,
    });
    return response.data;
  },

  getPackageById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/packages/${id}`);
    return response.data;
  },

  getPackageBySlug: async (slug) => {
    const response = await axios.get(`${API_BASE_URL}/packages/slug/${slug}`);
    return response.data;
  },

  getFeaturedPackages: async () => {
    const response = await axios.get(`${API_BASE_URL}/packages/featured`);
    return response.data;
  },

  searchPackages: async (searchTerm, filters = {}) => {
    const response = await axios.get(`${API_BASE_URL}/packages`, {
      params: {
        search: searchTerm,
        ...filters,
      },
    });
    return response.data;
  },

  calculatePrice: async (priceData) => {
    const response = await axios.post(`${API_BASE_URL}/packages/calculate-price`, priceData);
    return response.data;
  },
};

export default packageService;

